<template>
	<div class="relative mt-4">
		<div class="grid grid-cols-1 md:grid-cols-2 gap-5">
			<div v-for="(item, index) in testimonials" :key="index" class="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-100 relative flex flex-col min-h-[250px]">

				<!-- Testimonial Text -->
				<p class="text-gray-600 italic text-md mb-6 leading-relaxed z-10 relative flex-grow flex items-center">
					{{item.description}}
				</p>
				
				<!-- Author Info - Always at the bottom -->
				<div class="flex items-center z-10 relative mt-auto pt-4 border-t border-gray-100">
				<!-- Thumbnail/Profile Image -->
				<div class="flex-shrink-0 mr-4">
					<div class="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden border-2 border-white shadow-sm">
					<img 
						v-if="item.website && isValidWebsite(item.website)" 
						:src="'https://s2.googleusercontent.com/s2/favicons?domain_url=' + getDomain(item.website)" 
						:alt="item.company + ' favicon'" 
						class="w-6 h-6"
						@error="handleImageError"
					>
					<svg v-else xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
					</svg>
					</div>
				</div>
				
				<!-- Name and Company -->
				<div class="min-w-0">
					<h3 class="font-semibold text-gray-900 truncate">
					{{item.name}}
					</h3>
					<h4> 
						<a v-if="item.company" 
						:href="formatWebsite(item.website)" 
						target="_blank" 
						rel="noopener noreferrer" 
						class="text-red-500 hover:text-red-700 text-sm truncate block transition-colors duration-200"
						>
					{{ item.company }}
					</a></h4>
				</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'Testimonials',
	props: {
		testimonials: Array
	},
	methods: {
		formatWebsite(url) {
			if (!url) return '#';
			if (url.startsWith('http://') || url.startsWith('https://')) {
			return url;
			}
			return 'https://' + url;
		},
		
		isValidWebsite(url) {
			if (!url) return false;
			try {
			const formatted = this.formatWebsite(url);
			new URL(formatted);
			return true;
			} catch {
			return false;
			}
		},
		
		getDomain(url) {
			try {
			const formatted = this.formatWebsite(url);
			const domain = new URL(formatted).hostname;
			return domain;
			} catch {
			return '';
			}
		},
		
		handleImageError(event) {
			event.target.style.display = 'none';
			event.target.parentElement.innerHTML = `
			<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
			</svg>
			`;
		}
	}
}
</script>